// extracted by mini-css-extract-plugin
export var aggregationCell = "_2n-n";
export var aggregationRow = "_2n-m";
export var borderlessSpinnerContainer = "_2n-3";
export var cardLayout = "_2n-6";
export var cardLayoutNoFooter = "_2n-9";
export var cardLayoutPageControl = "_2n-8";
export var closeIcon = "_2n-f";
export var columnHeaderSurface = "_2n-b";
export var columnHeaderSurfaceDragOverlay = "_2n-v";
export var columnHeaderSurfaceResizing = "_2n-s";
export var contextMenuAnchor = "_2n-1";
export var draggableColumnHeader = "_2n-t";
export var draggableColumnHeaderOverlay = "_2n-u";
export var expandIcon = "_2n-g";
export var expanded = "_2n-h";
export var filterDropdown = "_2n-i";
export var filterDropdownDivider = "_2n-d";
export var filterDropdownHeader = "_2n-l";
export var filterDropdownItem = "_2n-k";
export var filterDropdownModal = "_2n-j _2n-i";
export var filterItem = "_2n-c";
export var normalCellWithAdjustableBorder = "_2n-e";
export var pinButtonContainer = "_2n-o";
export var pinIcon = "_2n-p";
export var pinIconActive = "_2n-q";
export var spinner = "_2n-0";
export var spinnerContainer = "_2n-2";
export var tableContainer = "_2n-4";
export var tableContentDraggingColumns = "_2n-a";
export var tableContentInner = "_2n-7";
export var tableContentWrapper = "_2n-5";
export var viewButtonContainer = "_2n-r";